import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import DateInput from "../../inputs/date-input";
import { SearchDropdown } from "../../inputs/search-dropdown";
import OptionToggler from "../../OptionToggler";

// Extracted from AddGoal.js's `modalState === "personalRecord"` block so the
// same exercise/reps/load/date fields can be reused inline in Periodization's
// manage-milestone-goals modal (see
// ~/.claude/plans/periodization-add-goal-modal.md Fase 2) without duplicating
// this JSX - purely presentational, all state/submit stays with the caller.
export const PersonalRecordFields = ({
  t,
  movementOptions,
  unitsOptions,
  units,
  selectedExercise,
  onSelectExercise,
  targetReps,
  setTargetReps,
  targetLoad,
  setTargetLoad,
  setTargetUnits,
  targetDate,
  setTargetDate,
}) => (
  <>
    <div className="form-col">
      <label htmlFor="selectExercise">
        {t("coaching-portal:addGoal.selectExistingExercise")}
      </label>
      <SearchDropdown
        options={movementOptions}
        placeholder={t("coaching-portal:addGoal.selectExercisePlaceholder")}
        handleChange={(val) => {
          if (val) onSelectExercise(val);
        }}
        value={selectedExercise}
        valueKey="label"
      />
    </div>

    <div className="form-col">
      <label htmlFor="targetReps">
        {t("coaching-portal:addGoal.numberOfReps")}
      </label>

      <input
        type="number"
        name="targetReps"
        placeholder={t("coaching-portal:addGoal.enterReps")}
        className="question-input"
        value={targetReps}
        onChange={(e) => {
          const { value } = e.target;

          setTargetReps(String(value));
        }}
      />
    </div>

    <div className="form-col">
      <label htmlFor="targetReps">{t("coaching-portal:addGoal.load")}</label>
      <div className="form-row">
        <input
          type="number"
          name="targetLoad"
          placeholder={t("coaching-portal:addGoal.enterLoad")}
          className="question-input"
          value={targetLoad}
          onChange={(e) => {
            const { value } = e.target;

            setTargetLoad(String(value));
          }}
        />
        <div className="metric-toggler">
          <OptionToggler
            name={"units"}
            options={unitsOptions}
            defaultValue={units}
            onSelectFn={(value) => {
              setTargetUnits(value);
            }}
          />
        </div>
      </div>
    </div>

    <div className="form-col">
      <label htmlFor="targetDate">
        {t("coaching-portal:addGoal.targetDate")}
      </label>

      <DateInput
        name="targetDate"
        placeholder={t("coaching-portal:addGoal.targetDatePlaceholder")}
        value={targetDate}
        min={moment().toDate()}
        onChange={(date) => setTargetDate(date)}
      />
    </div>
  </>
);

PersonalRecordFields.propTypes = {
  t: PropTypes.func.isRequired,
  movementOptions: PropTypes.array.isRequired,
  unitsOptions: PropTypes.array.isRequired,
  units: PropTypes.string,
  selectedExercise: PropTypes.string,
  onSelectExercise: PropTypes.func.isRequired,
  targetReps: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setTargetReps: PropTypes.func.isRequired,
  targetLoad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setTargetLoad: PropTypes.func.isRequired,
  setTargetUnits: PropTypes.func.isRequired,
  targetDate: PropTypes.instanceOf(Date),
  setTargetDate: PropTypes.func.isRequired,
};
